'use client';

import { useTranslations } from 'next-intl';

import { Typography } from '@/components/atoms';

export const Content = ({
  artistTop,
  title,
  artistBottom,
  onClick,
}: {
  artistTop: string;
  title: string;
  artistBottom: string;
  onClick?: (e: React.MouseEvent) => void;
}) => {
  const t = useTranslations();
  const label = (key: string, fallback: string) =>
    t.has(key) ? t(key) : fallback;

  const accessibleName = [
    artistTop && `${label('TRACK_LIST_COMPOSER', 'Composer')}: ${artistTop}`,
    `${label('TRACK_LIST_TITLE', 'Title')}: ${title}`,
    artistBottom &&
      `${label('TRACK_LIST_ARTISTS', 'Artists')}: ${artistBottom}`,
  ]
    .filter(Boolean)
    .join(', ');

  return (
    <button
      type="button"
      aria-label={accessibleName}
      className="flex flex-col gap-1 items-start self-stretch flex-1 min-w-0 w-full text-left cursor-pointer rounded-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-(--focus-ring-color)"
      onClick={onClick}
    >
      <Typography.Text
        as="span"
        variant="body"
        size="sm"
        weight="regular"
        className="line-clamp-1"
      >
        {artistTop}
      </Typography.Text>
      <Typography.Text
        as="span"
        variant="body"
        size="md"
        weight="semibold"
        className="line-clamp-3"
      >
        {title}
      </Typography.Text>
      <Typography.Text
        as="span"
        variant="body"
        size="sm"
        weight="regular"
        className="line-clamp-1"
      >
        {artistBottom}
      </Typography.Text>
    </button>
  );
};
